import use from "react-promise-suspense";
import { graphql, useFragment } from "react-relay";

import { config } from "~/data";
import { eventEmitter } from "~/lib/rosetta/event-emitter";
import { isSsr } from "~/lib/utils";
import type { hooksPaywallPromiseArticle$key } from "~/queries/__generated__/hooksPaywallPromiseArticle.graphql";

import { usePaywallCheckerContext } from "./contexts";

export const usePaywallPromise = (article_: hooksPaywallPromiseArticle$key) => {
  const { setPaywallMap } = usePaywallCheckerContext();
  const article = useFragment(
    graphql`
      fragment hooksPaywallPromiseArticle on Article {
        entityId
      }
    `,
    article_,
  );

  return use(
    (entityId: string, _: string) => {
      if (isSsr() || !config.features.enablePaywall) return Promise.resolve(undefined);
      return new Promise<boolean>(resolve => {
        const handler = (value: boolean) => {
          resolve(value);
          setPaywallMap?.(paywallMap => ({
            ...paywallMap,
            [entityId]: value,
          }));
          eventEmitter.removeListener("showInlineWall", handler);
        };
        eventEmitter.on("showInlineWall", handler);
      });
    },
    [article.entityId, "usePaywallPromise"],
  );
};
